export enum Container {
    NATIVE_OUTLOOK = 'Native_outlook',
}

export class GlobalConfiguration {
    public getVersion(): string {
        return __VERSION__ || 'v0.0.1';
    }
}